import { render, staticRenderFns } from "./AddUserFrom.vue?vue&type=template&id=6ed7dd41&scoped=true&"
import script from "./AddUserFrom.vue?vue&type=script&lang=js&"
export * from "./AddUserFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7dd41",
  null
  
)

export default component.exports